import {BaseEntity} from "./BaseEntity";

export class Event implements BaseEntity {
    constructor(
        public id?:number,
        public eventTime?:string,
        public rfidTag?: string,
        public vTagID?: string,
        public readerName?:string,
        public readerLocation?:string,
        public assetName?:string,
        public assetDescription?:string,
        public eventType?:string,
        public thresholdType?:string,
        public eventDetails?:string,
        public filterAnnotation?:string,
        public antennaNumber?:string,
        public rssi?:string){
    }
    parseJson(json: any): void {
        this.id = json.id;
        this.eventTime = json.eventTime;
        this.rfidTag = json.rfidTag;
        this.vTagID = json.vTagID;
        this.readerName = json.readerName;
        this.readerLocation = json.readerLocation;
        this.assetName = json.assetName;
        this.assetDescription = json.assetDescription;
        this.eventType = json.eventType;
        this.thresholdType = json.thresholdType;
        this.eventDetails = json.eventDetails;
        this.filterAnnotation = json.filterAnnotation;
        this.antennaNumber = json.antennaNumber;
        this.rssi = (json.rssi === "255") ? "" : json.rssi;
    }

}
